import React from 'react'

interface IProps {
  color: string;
  width?: number;
  height?: number;
  borderColor?: string;
}

const ColorBlock: React.FC<IProps> = ({ color, width = 16, height = 16, borderColor }) => {
  return (
    <div style={{ backgroundColor: color, width, height, ...(borderColor && { border: `1px solid ${borderColor}` }) }} />
  )
}

export default ColorBlock;